import React from 'react';
import { Button } from 'react-bootstrap';
import useApi from '../../api/backendApiContext';
import { analyticsTrack } from '../../web-analytics/webAnalytics';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';
import { openUrlInNewTab } from '../../util/window-utils';
import { useMutation } from '@tanstack/react-query';
import useAnalyticsPage from '../../web-analytics/hooks/useAnalyticsPage';
import { Page } from '../../web-analytics/Page';

export const MissingPaymentMethodBanner = () => {
  useAnalyticsPage(Page.MISSING_PAYMENT_METHOD_BANNER);
  const { billingApi } = useApi();

  const { isLoading, mutate: openAddPaymentMethod } = useMutation(
    async () => {
      const billingPortalSession = await billingApi.createBillingPortalSession();
      openUrlInNewTab(
        billingPortalSession.url,
        {
          analyticsEvent: AnalyticsEvent.BILLING_CARD_ADD_NEW_FROM_AUTO_PAYMENT,
        },
        '/payment-methods'
      );
    },
    {
      onError: () => {
        analyticsTrack(AnalyticsEvent.BILLING_PORTAL_FAILED);
      },
    }
  );

  return (
    <div className="billing__missing-payment-method-wrapper">
      <div className="billing__missing-payment-method-container">
        <div className="growegy-font16--weight500 growegy-font-em">Payment method required</div>
        <div className="growegy-font14">
          You have enabled automatic payments but have not added a payment method. Please add a
          payment method so Growegy can charge your invoices on their due date in accordance with
          our{' '}
          <a
            href="https://www.growegy.com/growegy-terms-and-conditions/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Conditions
          </a>
          .
        </div>
        <div>
          <Button
            variant="primary"
            className="button-apply"
            disabled={isLoading}
            onClick={() => openAddPaymentMethod()}
            data-test="billing-missing-payment-method__add-btn"
          >
            Add payment method
          </Button>
        </div>
      </div>
    </div>
  );
};
